/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { BaseModalProps, IconButton, colors, fonts, mixins, Modal } from '@blend/consumer-components';
import { useConsumerTheme } from '../../../../hooks/useConsumerTheme';
export interface AddressModalProps extends BaseModalProps {
  headerText: string;
}

const modalWidth = 450;
const headerHeight = 75;
const styles = StyleSheet.create({
  headerWrapper: {
    ...mixins.paddingHorizontal(30),
    position: 'relative',
    height: headerHeight,
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    borderBottom: `1px solid ${colors.snowPlus6}`,
  },
  headerText: {
    ...fonts.UntitledSans,
    ...mixins.textOverflow(),
    fontWeight: fonts.weight.medium,
    textAlign: 'center',
    color: colors.clayPlus4,
    fontSize: 18,
    margin: 0,
    width: '100%',
  },
  contentWrapper: {
    ...mixins.padding(0, 30, 24),
    width: '100%',
    overflowY: 'auto',
  },
});

const AddressModal: React.FunctionComponent<AddressModalProps> = props => {
  const { headerText, children, ...modalProps } = props;
  const { appConfig } = useConsumerTheme();
  const actionColor = appConfig.colors.action;

  return (
    <Modal {...modalProps} styleConfig={{ padding: 0, width: modalWidth }}>
      <div data-it="it-AddressModal-content">
        <header className={css(styles.headerWrapper)}>
          <h3 className={css(styles.headerText)} tabIndex={-1}>
            {headerText}
          </h3>
          <IconButton
            data-it="AddressModal-closeButton"
            icon="delete"
            onClick={modalProps.handleClose}
            actionColor={actionColor}
          />
        </header>
        <section data-it="AddressModalContent" className={css(styles.contentWrapper)}>
          {children}
        </section>
      </div>
    </Modal>
  );
};

export default AddressModal;
